import Raven from 'raven-js';
import moment from 'moment';

export function ConsumerService(localStorageService, DINING_OPTION, LOCAL_STORAGE) {
    'ngInject';
    const data = {
        address: '',
        diningOption: DINING_OPTION.DELIVERY,
        latitude: 0,
        longitude: 0
    };

    const svc = {
        data: data,
        getDiningOption: getDiningOption,
        getLocation: getLocation,
        setDiningOption: setDiningOption,
        setLocation: setLocation
    };
    return svc;

    function getDiningOption() {
        const diningOption = localStorageService.get(LOCAL_STORAGE.DINING_OPTION);

        if (diningOption) {
            return diningOption;
        }

        return DINING_OPTION.DELIVERY;
    }

    function getLocation() {
        const location = localStorageService.get(LOCAL_STORAGE.ADDRESS);

        if (location && location.dateTime) {
            const setDate = moment.parseZone(location.dateTime);
            const currentDate = moment();
            const dateIsValid = setDate.add(30, 'days').isAfter(currentDate);

            if (dateIsValid) {
                return location;
            }
        }

        return {};
    }

    function setLocation(latitude, longitude, addressComponents) {
        data.latitude = latitude;
        data.longitude = longitude;

        if (addressComponents.fromLocalStorage) {
            data.address = _parseAddressInfoFromLocalStorage(addressComponents.fromLocalStorage);
        } else if (addressComponents.fromGoogleAPI) {
            data.address = addressComponents.fromGoogleAPI.formattedAddress;
            _saveLocation(addressComponents.fromGoogleAPI.addressComponents);
        }
    }

    function setDiningOption(diningOption) {
        data.diningOption = diningOption;

        _saveDiningOption();
    }

    function _parseAddressInfoFromLocalStorage(addressInfo) {
        return [
            addressInfo.streetAddress1,
            addressInfo.streetAddress2,
            addressInfo.city,
            addressInfo.state,
            addressInfo.zipCode
        ].filter(Boolean).join(', ');
    }

    function _saveDiningOption() {
        if (!localStorageService.set(LOCAL_STORAGE.DINING_OPTION, data.diningOption) && !!data.diningOption) {
            _sendLocalStorageUnsupportedMessage('_saveDiningOption');
        }
    }

    function _saveLocation(addressComponents) {
        const addressInfo = {
            streetAddress1: '',
            streetAddress2: '',
            city: '',
            state: '',
            zipCode: '',
            latitude: data.latitude,
            longitude: data.longitude,
            dateTime: moment().toISOString()
        };

        addressComponents.forEach(
            component => {
                const type = component.types[0]; // TODO: there might be more than 1 type in component.types, perhaps we need a finer grain helper method to search in component.types for what we're looking for instead of getting the first element
                switch (type) {
                case 'street_number':
                    addressInfo.streetAddress1 = component.long_name;
                    break;
                case 'route':
                    addressInfo.streetAddress1 += ' ' + component.short_name;
                    break;
                case 'locality':
                    addressInfo.city = component.long_name;
                    break;
                case 'administrative_area_level_1':
                    addressInfo.state = component.short_name;
                    break;
                case 'postal_code':
                    addressInfo.zipCode = component.long_name;
                    break;
                default:
                }
            }
        );

        if (!localStorageService.set(LOCAL_STORAGE.ADDRESS, addressInfo) && !!addressInfo) {
            _sendLocalStorageUnsupportedMessage('_saveLocation');
        }
    }

    function _sendLocalStorageUnsupportedMessage(detailMessage) {
        Raven.captureMessage(`${LOCAL_STORAGE.UNSUPPORTED_MESSAGE} (${detailMessage})`, {
            level: 'info'
        });
    }
}
